import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { useTranslation } from 'react-i18next';
import { checkVietNam } from '@src/utils/checkCountry';
import { checkCustomPackage, formatPrice } from '@src/services/package';
import Text from '../Shared/Text';
import CheckOrCross from '../Shared/CheckOrCross';

const getPricePerDevice = (pkg, language) => {
  const isVietNam = checkVietNam();
  const vndPricePerUnit =
    pkg?.customResource?.devices?.prices?.[0]?.vndPricePerUnit;
  const usdPricePerUnit =
    pkg?.customResource?.devices?.prices?.[0]?.usdPricePerUnit;

  return formatPrice({
    vndPrice: vndPricePerUnit,
    usdPrice: usdPricePerUnit,
    isVietNam,
    language,
  });
};

const PurchaseAdditionalConcurrentDevicesFeature = ({ pkg }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isCustomPackage = checkCustomPackage({
    type: pkg.type,
    level: pkg.level,
  });

  if (isCustomPackage) {
    const pricePerDevice = getPricePerDevice(pkg, language);
    const description = pkg?.customResource?.devices?.description;

    return (
      <Text
        key={pkg.code}
        html={
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                t(description[language], {
                  pricePerUnit: pricePerDevice,
                }),
                {
                  allowedTags: ['span'],
                  allowedAttributes: {
                    span: ['style'],
                  },
                },
              ),
            }}
          />
        }
      />
    );
  }

  return <CheckOrCross key={pkg.code} isCheck={false} />;
};

const purchaseAdditionalConcurrentDevicesFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <PurchaseAdditionalConcurrentDevicesFeature key={pkg.code} pkg={pkg} />
  ));

export default purchaseAdditionalConcurrentDevicesFeatures;
